// utils/canadaFeedsConfig.js

  // Provincial information lookup table
  const provincialInfo = {
    alberta: { fullName: 'Alberta', code: 'ab', flagImage: '/albertaFlag.png', tableName: 'alberta' },
    british_columbia: { fullName: 'British Columbia', code: 'bc', flagImage: '/britishColumbiaFlag.png', tableName: 'british_columbia' },
    manitoba: { fullName: 'Manitoba', code: 'mb', flagImage: '/manitobaFlag.png', tableName: 'manitoba' },
    new_brunswick: { fullName: 'New Brunswick', code: 'nb', flagImage: '/newBrunswickFlag.png', tableName: 'new_brunswick' },
    newfoundland_labrador: { fullName: 'Newfoundland and Labrador', code: 'nl', flagImage: '/newfoundlandAndLabradorFlag.png', tableName: 'newfoundland_and_labrador' },
    northwest_territories: { fullName: 'Northwest Territories', code: 'nt', flagImage: '/northwestTerritoriesFlag.png', tableName: 'northwest_territories' },
    nova_scotia: { fullName: 'Nova Scotia', code: 'ns', flagImage: '/novaScotiaFlag.png', tableName: 'nova_scotia' },
    nunavut: { fullName: 'Nunavut', code: 'nu', flagImage: '/nunavutFlag.png', tableName: 'nunavut' },
    ontario: { fullName: 'Ontario', code: 'on', flagImage: '/ontarioFlag.png', tableName: 'ontario' },
    prince_edward_island: { fullName: 'Prince Edward Island', code: 'pe', flagImage: '/princeEdwardIslandFlag.png', tableName: 'prince_edward_island' },
    quebec: { fullName: 'Quebec', code: 'qc', flagImage: '/quebecFlag.png', tableName: 'quebec' },
    saskatchewan: { fullName: 'Saskatchewan', code: 'sk', flagImage: '/saskatchewanFlag.png', tableName: 'saskatchewan' },
    yukon: { fullName: 'Yukon', code: 'yt', flagImage: '/yukonFlag.png', tableName: 'yukon' }
  };

  export function createProvincialUpdateFeed(provinceKey) {
    const p = provincialInfo[provinceKey];
    if (!p) return null;
    return {
      id: `${p.code}Updates`,
      displayType: 'normal', 
      name: `${p.fullName} Updates`,  
      apiParams: `&skip=0&schema=canada&table=${p.tableName}&order_by=created_at`,  
      feedBranch: 'Updates',
      feedTopic: 'N/A',
      buttonName: 'Document',
      
    };
  }
  
  export function getProvincialUpdateFeed(provinceKey) {
    const feed = createProvincialUpdateFeed(provinceKey);
    return feed ? [feed] : [];
  }

export function getAllProvincialUpdateFeeds() {
  return Object.keys(provincialInfo)
    .map(createProvincialUpdateFeed)
    .filter(Boolean);
}
export const canadaFeedsConfig = {
  // Schema-level recents: one feed that hits
  // https://api.govglance.org/posts/recent/schema?limit=<n>&skip=0&schema=canada
  // (no table -> useFeedData routes it to /posts/recent/schema). The limit is
  // driven by the maxItems each view requests.
  recent: [
    {
      id: 'recent-ca-0',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=canada',
      title: 'Recents',
      feedName: 'Recents',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/canada/recents',
      showOnHomePage: true
    }
  ],
  
    legislative: [
        {
          id: 'billUpdates',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=bills&order_by=created_at',
          title: 'Bill Updates',
          feedName: 'Bill Updates',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Bill',
          viewAllLink: '/canada/legislative',
          showOnHomePage: true
        },
        {
          id: 'senate',
          type: 'normal',
          apiEndpoint: '&schema=canada&table=senate_news&order_by=created_at',
          title: 'Senate',
          feedName: 'Senate',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: true
        },
        {
          id: 'houseOfCommonsNews',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=house_of_commons&order_by=created_at',
          title: 'House of Commons News',
          feedName: 'House of Commons News',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: true
        },
        {
          id: 'committeeOnImmigration',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Citizenship%20and%20Immigration%20Committee',
          title: 'Standing Committee on Citizenship and Immigration',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnHR',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Human%20Resources%2C%20Skills%20and%20Social%20Development%20and%20the%20Status%20of%20Persons%20with%20Disabilities%20Committee',
          title: 'Human Resources, Skills and Social Development and the Status of Persons with Disabilities Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnIndigenousAffairs',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Indigenous%20and%20Northern%20Affairs%20Committee',
          title: 'Standing Committee on Indigenous and Northern Affairs',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnJustice',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Justice%20and%20Human%20Rights%20Committee',
          title: 'Justice and Human Rights Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnInfoPrivacy',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Access%20to%20Information%2C%20Privacy%20and%20Ethics%20Committee',
          title: 'Access to Information, Privacy and Ethics Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnHeritage',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Canadian%20Heritage%20Committee',
          title: 'Canadian Heritage Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnFinance',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Finance%20Committee',
          title: 'Standing Committee on Finance',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnAgriculture',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Agriculture%20and%20Agri-Food%20Committee',
          title: 'Standing Committee on Agriculture and Agri-Food',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnVeterans',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Veterans%20Affairs%20Committee',
          title: 'Standing Committee on Veterans\' Affairs',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnNaturalResources',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Natural%20Resources%20Committee',
          title: 'Standing Committee on Natural Resources',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnForeignAffairs',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Foreign%20Affairs%20and%20International%20Development%20Committee',
          title: 'Foreign Affairs and International Development Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnChinaRelations',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Canada-China%20Relations%20Committee',
          title: 'Special Committee on the Canada–People\'s Republic of China Relationship',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnPublicAccounts',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Public%20Accounts%20Committee',
          title: 'Public Accounts Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnIndustry',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Industry%20and%20Technology%20Committee',
          title: 'Standing Committee on Industry and Technology',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnLanguages',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Official%20Languages%20Committee',
          title: 'Official Languages Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnScience',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Science%20and%20Research%20Committee',
          title: 'Science and Research Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnEnvironment',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Environment%20and%20Sustainable%20Development%20Committee',
          title: 'Standing Committee on Environment and Sustainable Development',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnProcedure',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Procedure%20and%20House%20Affairs%20Committee',
          title: 'Procedure and House Affairs Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        },
        {
          id: 'committeeOnWomen',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Status%20of%20Women%20Committee',
          title: 'Status of Women Committee',
          feedName: 'Committees',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Document',
          viewAllLink: '/canada/legislative',
          showOnHomePage: false
        }
      ],
  
      executive: [
        {
          id: 'executiveNews',
          type: 'normal',
          apiEndpoint: '&schema=canada&table=prime_minister&order_by=created_at',
          title: 'Prime Minister\'s Office',
          feedName: 'Prime Minister\'s Office',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: true
        },
        {
          id: 'cra',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canada%20Revenue%20Agency',
          title: 'Canada Revenue Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'impactAssessment',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Impact%20Assessment%20Agency%20of%20Canada',
          title: 'Impact Assessment Agency of Canada',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Environment',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'foodInspection',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Food%20Inspection%20Agency',
          title: 'Canadian Food Inspection Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Health',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'atlanticOpportunities',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Atlantic%20Canada%20Opportunities%20Agency',
          title: 'Atlantic Canada Opportunities Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'feddevOntario',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Federal%20Economic%20Development%20Agency%20for%20Southern%20Ontario',
          title: 'Federal Economic Development Agency for Southern Ontario',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'borderServices',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canada%20Border%20Services%20Agency',
          title: 'Canada Border Services Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Defense',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'transportation',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Transportation%20Agency',
          title: 'Canadian Transportation Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Infrastructure',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'northernEconomicDevelopment',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Northern%20Economic%20Development%20Agency',
          title: 'Canadian Northern Economic Development Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'financialConsumer',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Financial%20Consumer%20Agency%20of%20Canada',
          title: 'Financial Consumer Agency of Canada',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'publicHealth',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Public%20Health%20Agency%20of%20Canada',
          title: 'Public Health Agency of Canada',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Health',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        },
        {
          id: 'spaceAgency',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Space%20Agency',
          title: 'Canadian Space Agency',
          feedName: 'Agencies',
          branch: 'Executive',
          topic: 'Science & Tech',
          buttonName: 'Doc',
          viewAllLink: '/canada/executive',
          showOnHomePage: false
        }
      ],
  
      judicial: [
        {
          id: 'courtReports',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=supreme_court&order_by=created_at&filter_column=collection_name&filter_string=Supreme%20Court%20Reports',
          title: 'Supreme Court Reports',
          feedName: 'Supreme Court Reports',
          branch: 'Judicial',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/judicial',
          showOnHomePage: true
        }
      ],
      economy: [
        {
          id: 'cra',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canada%20Revenue%20Agency',
          title: 'Canada Revenue Agency',
          feedName: 'Canada Revenue Agency',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: 'Doc',
          viewAllLink: '/canada/economy',
          showOnHomePage: true
        }
      ],
  
      environment: [
        {
          id: 'committeeOnEnvironment',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Environment%20and%20Sustainable%20Development%20Committee',
          title: 'Standing Committee on Environment and Sustainable Development',
          feedName: 'Environment Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/environment',
          showOnHomePage: true
        },
        {
          id: 'committeeOnAgriculture',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Agriculture%20and%20Agri-Food%20Committee',
          title: 'Standing Committee on Agriculture and Agri-Food',
          feedName: 'Agriculture Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/environment',
          showOnHomePage: true
        },
        {
          id: 'committeeOnNaturalResources',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Natural%20Resources%20Committee',
          title: 'Standing Committee on Natural Resources',
          feedName: 'Natural Resources Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/environment',
          showOnHomePage: true
        },
        {
          id: 'impactAssessment',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Impact%20Assessment%20Agency%20of%20Canada',
          title: 'Impact Assessment Agency of Canada',
          feedName: 'Impact Assessment Agency',
          branch: 'Executive',
          topic: 'Environment',
          buttonName: 'Doc',
          viewAllLink: '/canada/environment',
          showOnHomePage: false
        }
      ],
  
      science: [
        {
          id: 'committeeOnIndustry',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Industry%20and%20Technology%20Committee',
          title: 'Standing Committee on Industry and Technology',
          feedName: 'Industry and Technology Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/science&tech',
          showOnHomePage: true
        },
        {
          id: 'committeeOnScience',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Science%20and%20Research%20Committee',
          title: 'Science and Research Committee',
          feedName: 'Science and Research Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/science&tech',
          showOnHomePage: true
        },
        {
          id: 'committeeOnEnvironment',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Environment%20and%20Sustainable%20Development%20Committee',
          title: 'Standing Committee on Environment and Sustainable Development',
          feedName: 'Environment Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/science&tech',
          showOnHomePage: false
        }
      ],

      foreignAffairs: [
        {
          id: 'committeeOnForeignAffairs',
          type: 'normal',
          apiEndpoint: '&skip=0&schema=canada&table=committees&order_by=created_at&filter_column=collection_name&filter_string=Foreign%20Affairs%20and%20International%20Development%20Committee',
          title: 'Foreign Affairs and International Development Committee',
          feedName: 'Foreign Affairs Committee',
          branch: 'Legislative',
          topic: 'N/A',
          buttonName: 'Doc',
          viewAllLink: '/canada/foreign-affairs',
          showOnHomePage: true
        }
      ],
      provinces: Object.fromEntries(
        Object.keys(provincialInfo).map((k) => [k, getProvincialUpdateFeed(k)])
      )
      
  };
  

// Look up province metadata (flag, code, table)
export const getProvincialInfo = (provinceKey) => provincialInfo[provinceKey];

// (Optional) simple factory for now — no branch feeds yet
function createProvincialFeeds(provinceKey) {
  const p = provincialInfo[provinceKey];
  if (!p) return null;

  // You can wire these up later; returning empty arrays triggers "Coming Soon"
  return {
    legislative: [],
    executive:   [],
    judicial:    [],
  };
}

// Return feeds for a branch or [] (so the page can show "Coming Soon")
export const getProvincialFeedsByBranch = (provinceKey, branch) => {
  const all = createProvincialFeeds(provinceKey);
  if (!all) return [];
  return all[branch.toLowerCase()] || [];
};

  

  
  export const getFeedsByType = (sectionKey, type = 'normal') => {
    const sectionFeeds = canadaFeedsConfig[sectionKey] || [];
    return sectionFeeds.filter(feed => feed.type === type);
  };
  
  export const getNormalFeeds = (sectionKey) => {
    return getFeedsByType(sectionKey, 'normal');
  };
  
  export const getCarouselFeeds = (sectionKey) => {
    return getFeedsByType(sectionKey, 'carousel');
  };